// extracted by mini-css-extract-plugin
export default {"title":"style_title__TKHwF","locations":"style_locations__1BPP9"};